import { Component, Ref } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * Image Slider
 */
@Component
export class ImageSlider extends ThemeComponent {
    @Ref({ required: false }) overlay!: HTMLDivElement;
    @Ref({ required: false }) overlayConstraint!: HTMLDivElement;
    @Ref({ required: false }) slider!: HTMLDivElement;
    @Ref({ required: false }) sliderWrapper!: HTMLDivElement;

    private isActive: boolean = false;
    private overlayWidth: number = 0;
    private overlayHeight: number = 0;

    init() {
        if (!this.overlay && !this.overlayConstraint && !this.slider) { return; }

        this.setupSlider();
        this.addListeners();

        window.addEventListener('resize', () => {
            this.adjustSliderWidth();
        });
    }

    setupSlider() {
        // Notes:
        // overlayConstraint is used as this loads the after image where the height/width dimensions don't change
        // this is then used to calculate the boundaries for the (before) overlay image

        this.adjustSliderHeight();

        this.overlayWidth = this.overlayConstraint.offsetWidth;
        this.overlay.style.width = (this.overlayWidth / 2) + 'px';

        this.slider.style.top = (this.overlayConstraint.offsetHeight / 2) - (this.slider.offsetHeight / 2) + 'px';
        this.slider.style.left = (this.overlayWidth / 2) - (this.slider.offsetWidth / 2) + 'px';
        this.slider.style.height = `${this.overlayConstraint.offsetHeight}px`;

        const sliderContainers = document.querySelectorAll<HTMLElement>('.image-slider');

        if (sliderContainers) {
            for (const slider of sliderContainers) {

                const images = slider.querySelectorAll<HTMLElement>('.image-slider__image img');
                for (const image of images) {
                    image.style.width = `${slider.offsetWidth}px`;
                    image.style.objectFit = 'cover';
                }
            }
        }
    }

    adjustSliderWidth() {
        const beforeAfterSlider = document.querySelectorAll<HTMLElement>('.before-after-slider');

        const browserWidth = window.innerWidth || 0;

        for (const slider of beforeAfterSlider) {
            const child = slider.querySelector<HTMLElement>('.before-after-slider__wrapper');
            const imgSliders = slider.getElementsByTagName('image-slider');

            const imgSlidersArray = Array.from(imgSliders);
            for (const imgSlider of imgSlidersArray) {
                if (imgSlider instanceof HTMLElement) {
                    if (browserWidth > 768 && browserWidth <= 1024) {
                        imgSlider.style.width = '475px';
                    }
                    else if (browserWidth > 1024 && browserWidth <= 1200) {
                        imgSlider.style.width = '556px';
                    }
                    else if (browserWidth > 1200) {
                        imgSlider.style.width = '645px';
                    }
                    else {
                        imgSlider.style.width = `${child?.offsetWidth}px`;
                    }
                }
            }
        }
    }

    adjustSliderHeight() {
        const height = window.innerWidth > 768 ? 468 : 320;
        this.sliderWrapper.style.height = `${height}px`;
    }

    addListeners() {
        this.$listen(window, 'resize', () => {
            this.setupSlider();
        });

        this.$listen(this.slider, 'mousedown', (e: MouseEvent) => {
            this.slideReady(e);
        });

        this.$listen(window, 'mouseup', () => {
            this.slideFinish();
        });

        this.$listen(this.slider, 'touchstart', (e: TouchEvent) => {
            this.slideReady(e);
        });

        this.$listen(window, 'touchend', () => {
            this.slideFinish();
        });
    }

    slideReady(e: MouseEvent | TouchEvent) {
        e.preventDefault();

        this.isActive = true;

        this.$listen(window, 'mousemove', (e: MouseEvent) => {
            this.slideMove(e);
        });

        this.$listen(window, 'touchmove', (e: TouchEvent) => {
            this.slideMove(e);
        });
    }

    slideFinish() {
        this.isActive = false;
    }

    slideMove(e: MouseEvent | TouchEvent) {
        if (!this.isActive) { return; }

        let position = this.getMousePosition(e);

        if (position < 0) { position = 0; }
        if (position > this.overlayWidth) { position = this.overlayWidth; }

        this.slide(position);
    }

    slide(x: number) {
        this.overlay.style.width = x + 'px';
        this.slider.style.left = this.overlay.offsetWidth - (this.slider.offsetWidth / 2) + 'px';
    }

    getMousePosition(e: MouseEvent | TouchEvent) {
        const bounds = this.overlay.getBoundingClientRect();
        let coordinates;

        if (e instanceof TouchEvent) {
            coordinates = e.changedTouches[0].pageX - bounds.left;
        } else {
            coordinates = e.pageX - bounds.left; //x position within the element.
        }

        coordinates = coordinates - window.scrollX;

        return coordinates;
    }
}
